/* NuovaGlam — garantie à vie payante dans le panier (22/10/2026), même mécanique que assets/ng-ship-protection.js :
   - l'interrupteur [data-ng-wty-toggle] ajoute / retire SA variante (jamais pré-cochée) ;
   - cart/update.js passe par le fetch d'une iframe vide : un frais non produit ne doit pas émettre d'AddToCart Meta
     (mesuré le 02/10, standard shopify-atc-tracking.md) ;
   - la garantie part seule si le panier ne contient plus aucun article payant (rien à garantir), et reste à quantité 1.
   Config : window.NG_CART_WTY = { variants: [id, …] } posé par layout/theme.liquid. */
(() => {
  if (window.__ngCartWty) return;
  window.__ngCartWty = true;
  const SOURCE = 'ng-cart-wty';
  const config = window.NG_CART_WTY || { variants: [] };
  const WTY = (config.variants || []).map(Number).filter(Boolean);
  const PROT = ((window.NG_SHIP_PROT || {}).all || []).map(Number).filter(Boolean);
  const route = (path) => (window.Shopify?.routes?.root || '/') + path;
  const absolute = (path) => window.location.origin + route(path);
  let rawFetch = null;

  function cleanFetch() {
    if (rawFetch) return rawFetch;
    try {
      const frame = document.createElement('iframe');
      frame.hidden = true;
      frame.setAttribute('aria-hidden', 'true');
      frame.tabIndex = -1;
      document.body.appendChild(frame);
      rawFetch = frame.contentWindow.fetch.bind(frame.contentWindow);
    } catch {
      rawFetch = window.fetch.bind(window);
    }
    return rawFetch;
  }

  const isWty = (item) => WTY.includes(item.variant_id);
  const isAddon = (item) => isWty(item) || PROT.includes(item.variant_id);

  async function readCart() {
    const response = await fetch(route('cart.js'), { headers: { Accept: 'application/json' }, cache: 'no-store', credentials: 'same-origin' });
    if (!response.ok) throw new Error(`cart ${response.status}`);
    return response.json();
  }

  async function update(updates) {
    const response = await cleanFetch()(absolute('cart/update.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates }),
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok || data.status) throw new Error(data.description || data.message || `update ${response.status}`);
    return data;
  }

  async function render(cart) {
    const hosts = ['cart-drawer-items', 'cart-items']
      .map((selector) => document.querySelector(selector))
      .filter((host) => host && typeof host.getSectionsToRender === 'function')
      .map((host) => ({ host, sections: host.getSectionsToRender() }));
    if (!hosts.length) return;
    const ids = [...new Set(hosts.flatMap(({ sections }) => sections.map((section) => section.section)))];
    const response = await fetch(`${route('cart')}?sections=${ids.join(',')}`, { credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) throw new Error(`sections ${response.status}`);
    const html = await response.json();
    const empty = cart.item_count === 0;
    hosts.forEach(({ host, sections }) => {
      host.classList.toggle('is-empty', empty);
      sections.forEach((section) => {
        const root = document.getElementById(section.id);
        if (!root || typeof html[section.section] !== 'string') return;
        const target = (section.selector && root.querySelector(section.selector)) || root;
        const node = new DOMParser().parseFromString(html[section.section], 'text/html').querySelector(section.selector || '.shopify-section');
        if (node) target.innerHTML = node.innerHTML;
      });
    });
    document.querySelector('cart-drawer')?.classList.toggle('is-empty', empty);
    document.getElementById('main-cart-footer')?.classList.toggle('is-empty', empty);
  }

  const announce = () => {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: SOURCE });
  };
  const busy = (on) => document.querySelectorAll('[data-ng-wty-box]').forEach((box) => box.classList.toggle('is-busy', on));

  let queue = Promise.resolve();
  const enqueue = (task) =>
    (queue = queue.then(async () => {
      busy(true);
      try {
        const cart = await task();
        if (cart) {
          await render(cart);
          announce();
        }
      } catch (error) {
        console.error('[NuovaGlam lifetime warranty]', error);
        try {
          await render(await readCart());
        } catch {}
      } finally {
        busy(false);
      }
    }));

  function plan(cart) {
    const items = cart.items || [];
    // Seuls les articles PAYANTS comptent : un cadeau à 0 € retiré après la ceinture ne doit pas garder la garantie.
    const others = items.filter((item) => !isAddon(item) && item.final_line_price > 0).reduce((sum, item) => sum + item.quantity, 0);
    const updates = {};
    items.filter(isWty).forEach((item) => {
      if (!others) updates[item.key] = 0;
      else if (item.quantity !== 1) updates[item.key] = 1;
    });
    return Object.keys(updates).length ? updates : null;
  }

  async function reconcile() {
    const cart = await readCart();
    const updates = plan(cart);
    return updates ? update(updates) : null;
  }

  async function toggle(variantId, wanted) {
    const cart = await readCart();
    const own = (cart.items || []).find((item) => item.variant_id === variantId);
    if (wanted) return own ? (own.quantity === 1 ? null : update({ [own.key]: 1 })) : update({ [variantId]: 1 });
    return own ? update({ [own.key]: 0 }) : null;
  }

  document.addEventListener(
    'change',
    (event) => {
      const input = event.target.closest?.('[data-ng-wty-toggle]');
      if (!input) return;
      event.stopPropagation();
      const wanted = input.checked;
      input.closest('[data-ng-wty-box]')?.classList.toggle('is-on', wanted);
      enqueue(() => toggle(Number(input.dataset.variantId), wanted));
    },
    true
  );

  window.NuovaGlamCartWty = { plan, reconcile: () => enqueue(reconcile), idle: () => queue };

  const start = () => {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event?.source !== SOURCE) setTimeout(() => enqueue(reconcile), 0);
      });
    }
    if (config.checkOnLoad) enqueue(reconcile);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
